module.exports = __webpack_public_path__ + "site/img/signin.14dbe52c.jpg";